import { GridColDef } from "@mui/x-data-grid";

import { formatMoney, formatNumber, formatQuantity, TranslationFunction } from "../utils";

/**
 * Display rules shared by everything that shows parts - the stock pages, the
 * job views and the four statistics pages that each render their own "Used
 * Parts" breakdown.
 *
 * Quantities go through `formatQuantity` (no ",00" tail on a whole number) and
 * money through `formatNumber`/`formatMoney` (grouped, comma decimal mark), so
 * the same value reads the same way wherever it appears.
 */

/** Columns for the "Used Parts" breakdown table. Identical on the general,
 * group, technician and equipment statistics pages - the general one appends
 * its "Top Equipment" column to these.
 *
 * The value column's header already carries the currency ("Value (zł)"), so
 * the cell formats the number without repeating it. */
export const buildUsedPartsBreakdownColumns = (t: TranslationFunction): GridColDef[] => [
  { field: "part_name", headerName: t("Part"), flex: 1, minWidth: 160 },
  {
    field: "quantity",
    headerName: t("Quantity"),
    width: 120,
    valueGetter: (value) => formatQuantity(value),
  },
  {
    field: "value",
    headerName: t("Value (zł)"),
    width: 120,
    valueGetter: (value) => formatNumber(value),
  },
];

/** The "Used Parts" stat card value: how many were used, and what they cost. */
export const formatUsedPartsTotals = (
  usedParts: { count: number; total_value: number } | undefined
): string => {
  if (!usedParts) return "-";

  return `${usedParts.count} (${formatMoney(usedParts.total_value)})`;
};
